var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvaliacoes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78054 17.3055H2.56374C1.37558 17.3055 0.412109 16.3951 0.412109 15.2723V3.29686C0.412109 2.17411 1.37558 1.26367 2.56374 1.26367H4.32055",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9082 1.26367H11.6322C12.8062 1.26367 13.7582 2.17078 13.7582 3.28943V12.3005",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 4.48242H11.8734",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 7.03906H11.8734",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 9.60547H10.37",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 12.1719H8.15382",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 14.7383H7.44475",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3601 18.4682C14.2449 18.4682 15.7729 16.9402 15.7729 15.0554C15.7729 13.1705 14.2449 11.6426 12.3601 11.6426C10.4752 11.6426 8.94727 13.1705 8.94727 15.0554C8.94727 16.9402 10.4752 18.4682 12.3601 18.4682Z",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24319 0.365234H4.93593C4.6078 0.365234 4.3418 0.631238 4.3418 0.95937V1.80933C4.3418 2.13746 4.6078 2.40346 4.93593 2.40346H9.24319C9.57132 2.40346 9.83732 2.13746 9.83732 1.80933V0.95937C9.83732 0.631238 9.57132 0.365234 9.24319 0.365234Z",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 15.2888L11.9377 16.2324L13.9092 13.8809",
    stroke: "black",
    strokeWidth: 0.641673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliacoes);
export default __webpack_public_path__ + "static/media/Avaliacoes.32dda85c57be2f436f77a4cac5fb6bbb.svg";
export { ForwardRef as ReactComponent };